module.exports = __webpack_public_path__ + "img/kefu.e8b5e225.png";